/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from 'react';

import {
	useBuildQueryString,
	useChangeContext,
	useChangeContextAndTool,
	useChangeContextFromString,
	useChangeTool,
	useClearContext,
	useGetContext,
	useGetQueryStringParameter,
	useGetUrlContextSegment,
	useGetUrlToolSegment,
} from "../../../Hooks/RouteHooks";

export const StreamBankRoutingEnhance = ((ComposedComponent) => function StreamBankRoutingEnhance(props) {
    const getContext = useGetContext();
    const getUrlContextSegment = useGetUrlContextSegment();
    const getUrlToolSegment = useGetUrlToolSegment();
    const getQueryStringParameter = useGetQueryStringParameter();
    const buildQueryString = useBuildQueryString();
    const clearContext = useClearContext();
    const changeContext = useChangeContext();
    const changeContextFromString = useChangeContextFromString();
    const changeTool = useChangeTool();
    const changeContextAndTool = useChangeContextAndTool();

    return <ComposedComponent
        {...props}
        GetContext={getContext}
        GetUrlContextSegment={getUrlContextSegment}
        GetUrlToolSegment={getUrlToolSegment}
        GetQueryStringParameter={getQueryStringParameter}
        BuildQueryString={buildQueryString}
        ClearContext={clearContext}
        ChangeContext={changeContext}
        ChangeContextFromString={changeContextFromString}
        ChangeTool={changeTool}
        ChangeContextAndTool={changeContextAndTool}
    />;
});
